import { ICheckoutAction, CheckoutActionTypes } from "./checkout.actions";
import { Reducer } from "redux";
import { ICheckoutContainerState } from "./checkout";

const initialState: ICheckoutContainerState = {
    customerInformation: {
        billingAddressSameAsShipping: true
    },
    setCustomerInformationSuccess: false,
    customerInformationLoaded: false,
    shippingInformation: [],
    shippingInformationLoaded: false,
    setShippingInformationSuccess: false
};

export const checkoutReducer: Reducer<ICheckoutContainerState, ICheckoutAction> = (state = initialState, action): ICheckoutContainerState => {
    switch (action.type) {
        case CheckoutActionTypes.SET_CUSTOMER_INFORMATION_SUCCESS:
            return {
                ...state,
                customerInformation: action.customerInformation,
                setCustomerInformationSuccess: true
            }
        case CheckoutActionTypes.LOAD_CUSTOMER_INFORMATION:
            return {
                ...state,
                customerInformationLoaded: false,
            }
        case CheckoutActionTypes.LOAD_CUSTOMER_INFORMATION_SUCCESS:
            return {
                ...state,
                customerInformation: action.customerInformation,
                customerInformationLoaded: true
            }
        case CheckoutActionTypes.LOAD_SHIPPING_INFORMATION:
            return {
                ...state,
                shippingInformationLoaded: false,
            }
        case CheckoutActionTypes.LOAD_SHIPPING_INFORMATION_SUCCESS:
            return {
                ...state,
                shippingInformation: action.shippingInformation,
                shippingInformationLoaded: true
            }
        case CheckoutActionTypes.SET_SHIPPING_INFORMATION:
            return {
                ...state,
                selectedShippingInformation: state.shippingInformation.find(si => si.deliveryId === action.shippingInformation.deliveryId),
                setShippingInformationSuccess: true
            }
        case CheckoutActionTypes.SET_SHIPPING_INFORMATION_SUCCESS:
            return {
                ...state,
                setShippingInformationSuccess: true
            }
        case CheckoutActionTypes.LOAD_ORDER_INFORMATION_SUCCESS:
            return {
                ...state,
                orderInformation: action.orderInformation
            }
        default:
            return state;
    }
}
